import { useMemo } from 'react';
import * as currencyHooks from './hooks/useCurrencyFormatter';
import { useFormatter as useFormatterCore } from '@core/js/hooks/useFormatter/useFormatter';

export const useFormatter = () => {
    const { getRoundingBalance } = currencyHooks.useCurrencyFormatter();
    const coreFormatters = useFormatterCore(); // We're using original hook, so no need to change this file on c-merge

    return useMemo(() => ({
        ...coreFormatters,

        /**
            * Gets the balance value rounded down with a currency sign and a comma after thousands
            * @param [amount] {string} - amount options
            * @param [options] {string|object} - currency code or currency options, if not passed, user's currency is used
            * @return {string}
        */
        getRoundingBalance
    }), [coreFormatters, getRoundingBalance]);
};

